import {
  SET_SELECTED_COMPLEX,
  SET_SELECTED_ITEM_TYPE,
  SET_SELECTED_REAL_ESTATE,
  SET_SELECTED_BUILDINGS,
  SET_SELECTED_LEVEL_DASHBOARD,
  SET_SELECTED_ROOM_TYPES,
  SET_TIME_SETTING,
  SET_SELECTED_DATE_INTERVAL,
  SET_SELECTED_WORK_TIME,
  SET_ONLY_BOOKABLE,
  SET_IS_FILTER_BUTTON_DISABLED,
  SET_ROOM_SIZE,
  SET_FORM,
  SET_QUICK_SELECT
} from '@/store/mutation-types'
import {
  CHANGE_COMPLEX_DASHBOARD,
  CHANGE_REAL_ESTATE_DASHBOARD,
  CHANGE_BUILDING_DASHBOARD,
  CHANGE_LEVEL_DASHBOARD,
  RESET_DASHBOARD_FILTER
} from '@/store/action-types'
import { getPreviousMondayAndSunday } from '@/utils/date'
import { QUICK_SELECTS } from '@/components/types'
const [previousMonday, previousSunday] = getPreviousMondayAndSunday()

export default {
  namespaced: true,
  state: {
    selectedComplex: null,
    selectedItemType: 'region',
    selectedRealEstate: null,
    selectedBuildings: [],
    selectedLevel: null,
    selectedDateInterval: {
      end: previousSunday.toISOString().split('T')[0],
      start: previousMonday.toISOString().split('T')[0]
    },
    selectedQuickSelect: QUICK_SELECTS[2],
    selectedWorkTime: { onlyWorkDays: true, onlyWorkHours: true },
    onlyBookable: false,
    timeSetting: 'DAY',
    selectedRoomTypes: [],
    isFilterButtonDisabled: true,
    roomSize: []
  },
  getters: {
    selectedWorkTime: (state) => {
      return state.selectedWorkTime
    },
    selectedComplexId: (state) => {
      return state.selectedComplex != null ? state.selectedComplex.belongsToId : ''
    },
    selectedComplexName: (state) => {
      return state.selectedComplex != null ? state.selectedComplex.title : ''
    },
    // the different states needs to be made and added if they dont exist.
    selectedObject: (state) => {
      switch (state.selectedItemType) {
        case 'complex':
          return state.selectedComplex
        case 'realEstate':
          return state.selectedRealEstate
        case 'buildings':
          return state.selectedBuildings
        case 'level':
          return state.selectedLevel
      }
    },
    selectedRealEstateId: (state) => {
      return state.selectedRealEstate != null ? state.selectedRealEstate.id : ''
    },
    selectedRealEstateName: (state) => {
      return state.selectedRealEstate != null ? state.selectedRealEstate.name : ''
    },
    selectedBuildingName: (state) => {
      return state.selectedBuildings.length == 1 ? state.selectedBuildings[0].name : ''
    },
    selectedLevelName: (state) => {
      return state.selectedLevel != null ? state.selectedLevel.name : ''
    }
  },
  mutations: {
    [SET_QUICK_SELECT](state, payload) {
      state.selectedQuickSelect = payload
    },
    [SET_FORM](state, payload) {
      state.selectedQuickSelect = payload.selectedQuickSelect
      state.selectedWorkTime = payload.selectedWorkTime
      state.selectedDateInterval = payload.selectedDateInterval
    },
    [SET_SELECTED_COMPLEX](state, payload) {
      state.selectedComplex = payload.complex
    },
    [SET_SELECTED_ITEM_TYPE](state, payload) {
      if (
        ['buildings', 'complex', 'level', 'realEstate', 'room', 'region'].indexOf(payload) !== -1
      ) {
        state.selectedItemType = payload
      } else {
        console.error('Item type ' + payload + ' is not supported')
      }
    },
    [SET_SELECTED_REAL_ESTATE](state, payload) {
      state.selectedRealEstate = payload.realEstate
    },
    [SET_SELECTED_BUILDINGS](state, payload) {
      state.selectedBuildings = [...payload.buildings]
    },
    [SET_SELECTED_LEVEL_DASHBOARD](state, payload) {
      state.selectedLevel = payload.level
    },
    [SET_SELECTED_ROOM_TYPES](state, payload) {
      state.selectedRoomTypes = [...payload.roomTypes]
    },
    [SET_TIME_SETTING](state, payload) {
      state.timeSetting = payload
    },
    [SET_SELECTED_DATE_INTERVAL](state, payload) {
      state.selectedDateInterval = payload
    },
    [SET_SELECTED_WORK_TIME](state, payload) {
      state.selectedWorkTime = payload
    },
    [SET_ONLY_BOOKABLE](state, payload) {
      state.onlyBookable = payload
    },
    [SET_IS_FILTER_BUTTON_DISABLED](state, payload) {
      state.isFilterButtonDisabled = payload
    },
    [SET_ROOM_SIZE](state, payload) {
      state.roomSize = payload
    }
  },
  actions: {
    [CHANGE_COMPLEX_DASHBOARD]({ commit, state }, payload) {
      commit(SET_SELECTED_COMPLEX, payload)
      commit(SET_SELECTED_REAL_ESTATE, { realEstate: null })
      commit(SET_SELECTED_BUILDINGS, { buildings: [] })
      commit(SET_SELECTED_LEVEL_DASHBOARD, { level: null })
      commit(SET_SELECTED_ROOM_TYPES, { roomTypes: [] })
      if (state.selectedComplex == null) commit(SET_SELECTED_ITEM_TYPE, 'region')
      else commit(SET_SELECTED_ITEM_TYPE, 'complex')
    },
    [CHANGE_REAL_ESTATE_DASHBOARD]({ commit, state }, payload) {
      commit(SET_SELECTED_REAL_ESTATE, payload)
      commit(SET_SELECTED_BUILDINGS, { buildings: [] })
      commit(SET_SELECTED_LEVEL_DASHBOARD, { level: null })
      commit(SET_SELECTED_ROOM_TYPES, { roomTypes: [] })
      if (state.selectedRealEstate == null) {
        if (state.selectedComplex != null) commit(SET_SELECTED_ITEM_TYPE, 'complex')
        else if (state.selectedComplex == null) commit(SET_SELECTED_ITEM_TYPE, 'region')
      } else commit(SET_SELECTED_ITEM_TYPE, 'realEstate')
    },
    [CHANGE_BUILDING_DASHBOARD]({ commit, state }, payload) {
      commit(SET_SELECTED_BUILDINGS, payload)
      commit(SET_SELECTED_LEVEL_DASHBOARD, { level: null })
      commit(SET_SELECTED_ROOM_TYPES, { roomTypes: [] })
      if (state.selectedBuildings == []) {
        if (state.selectedRealEstate != null) commit(SET_SELECTED_ITEM_TYPE, 'realEstate')
        else if (state.selectedComplex != null) commit(SET_SELECTED_ITEM_TYPE, 'complex')
        else if (state.selectedComplex == null) commit(SET_SELECTED_ITEM_TYPE, 'region')
      } else commit(SET_SELECTED_ITEM_TYPE, 'buildings')
    },
    [CHANGE_LEVEL_DASHBOARD]({ commit, state }, payload) {
      commit(SET_SELECTED_LEVEL_DASHBOARD, payload)
      commit(SET_SELECTED_ROOM_TYPES, { roomTypes: [] })
      if (state.selectedLevel == null) {
        if (state.selectedBuildings != []) commit(SET_SELECTED_ITEM_TYPE, 'buildings')
        else if (state.selectedRealEstate != null) commit(SET_SELECTED_ITEM_TYPE, 'realEstate')
        else if (state.selectedComplex != null) commit(SET_SELECTED_ITEM_TYPE, 'complex')
        else if (state.selectedComplex == null) commit(SET_SELECTED_ITEM_TYPE, 'region')
      } else commit(SET_SELECTED_ITEM_TYPE, 'level')
    },
    [RESET_DASHBOARD_FILTER]({ commit }) {
      commit(SET_SELECTED_COMPLEX, { complex: null })
      commit(SET_SELECTED_REAL_ESTATE, { realEstate: null })
      commit(SET_SELECTED_BUILDINGS, { buildings: [] })
      commit(SET_SELECTED_LEVEL_DASHBOARD, { level: null })
      commit(SET_SELECTED_ROOM_TYPES, { roomTypes: [] })
      commit(SET_SELECTED_ITEM_TYPE, 'region')
      commit(SET_SELECTED_WORK_TIME, { onlyWorkDays: true, onlyWorkHours: true })
      commit(SET_TIME_SETTING, 'DAY')
      commit(SET_ONLY_BOOKABLE, false)
      commit(SET_QUICK_SELECT, QUICK_SELECTS[2])
    }
  }
}
